/**
 * Created by Stefano Mandruzzato on 21/03/18.
 */
export default function PecImportController($log, $state, moment, _, LmrcApiService, EmailService, queryParamGetter) {
    'ngInject';
    var LOGGER = $log.getInstance('PecImportController');
    var vm = this;
    vm.initLoading = false;
    vm.isInitialized = false;
    vm.dateFrom = null;
    vm.showDate = false;
    vm.customPwdWarnMessage = "Non è stato possibile impostare la password sulla medesima casella creata presso il nuovo gestore PEC.\n" +
      "Al termine del processo di migrazione, per impostare la password di accesso alla nuova casella PEC, clicca sul pulsante \"NON RIESCI AD ACCEDERE\"";
    // magicamente la mail c'e', deve esserci anche la user secondaria/multicasella nel caso specifico... scopri dove XD
    LOGGER.debug('email', vm.email);

    //datepicker
    vm.datePickerOpened = false;
    //DATE
    vm.dateOptions = {
        formatYear: 'yy',
        startingDay: 1,
        maxDate: new Date()
    };
    vm.dateFormat = 'dd-MM-yyyy';
    vm.altInputFormats = ['d!/M!/yyyy', 'd!.M!.yyyy', 'd!-M!-yyyy'];
    vm.inputSsl = false;
    vm.openDatePicker = function($event) {
        vm.datePickerOpened = true;
    };

    vm.emailService = EmailService;
    vm.accessType = vm.emailService.getAccessType();
    vm.username = vm.emailService.getUsername();
    vm.personalizationId = vm.emailService.getPersonalizationId();

    vm.startMigration = function(isFormValid) {
        if (isFormValid) {
            vm.errorMessage = '';
            if (vm.inputDate) {
                LOGGER.debug('dateFrom', vm.inputDate);
                vm.dateFrom = moment(vm.inputDate).format("YYYY-MM-DD");
            }
            let email = vm.email || vm.inputEmail;
            LOGGER.debug('email', email);
            if (!email.includes('@')) {
                vm.errorMessage = 'input non validi';
                return;
            }
            let emailUser = email.split('@')[0];
            let emailDomain = email.split('@')[1];
            LOGGER.debug('emailUser', email);
            LOGGER.debug('emailDomain', emailDomain);
            const request = {
                emailDomain,
                emailUser,
                password: vm.inputPassword,
                dateFrom: vm.dateFrom ? vm.dateFrom : null,
                username: vm.username ? vm.username : null,
                personalizationId: vm.personalizationId ? vm.personalizationId : null,
                //inserire userId (per slave e master) e personalizationId (in tutti i casi)
                // se e' una slave/multicasella deve esserci l'utenza
                // inserire anche personalization
                skipMigration: false
            };
            LOGGER.debug('request', request);
            vm.loading = true;

            const defaultGoToPhase = 'external.contact-info';
            var onCompletionGoTo = Promise.resolve(defaultGoToPhase);
            var skipMigration = Promise.resolve(false);
            const customizationId = _.trim(queryParamGetter('ui', true));
            if (customizationId) { // customizationId = personalizationId
                request.personalizationId = customizationId;
                var customizationPromise = LmrcApiService.getCustomization(customizationId);
                skipMigration = customizationPromise
                    .then(resp => {
                        LOGGER.debug("getCustomization response", resp.data);
                        LOGGER.debug("getCustomization skipMigration?", resp.data.skipMigration);

                        if (resp.data.skipMigration) {
                            return true;
                        }
                        return false;
                    }, err => {
                        LOGGER.debug("getCustomization failed, using default conf", err);
                        return false;
                    })
                onCompletionGoTo = customizationPromise
                    .then(resp => {
                        LOGGER.debug("getCustomization customPwdWarnMessage?", resp.data.customPwdWarnMessage);
                        if (isFilled(resp.data.customPwdWarnMessage)) {
                          vm.customPwdWarnMessage = resp.data.customPwdWarnMessage;
                        }
                        LOGGER.debug("getCustomization response", resp.data);
                        LOGGER.debug("getCustomization skipContactInfoPhase?", resp.data.skipContactInfoPhase);
                        if (resp.data.skipContactInfoPhase) {
                            LOGGER.debug("getCustomization doChangePasswordPhase?", resp.data.doChangePasswordPhase);
                            if (resp.data.doChangePasswordPhase) {
                                return 'external.change-password'
                            } else {
                                return 'external.success';
                            }
                        } else {
                            return defaultGoToPhase;
                        }
                    }, err => {
                        LOGGER.debug("getCustomization failed, using default conf", err);
                        return defaultGoToPhase;
                    });
            } else {
                logger.debug("getCustomization no customization")
            }

            // request.skipMigration = skipMigration.resolve();
            return skipMigration.then(shouldSkip=>{
                request.skipMigration = shouldSkip;
                return LmrcApiService.startMigration(request)
            } )
                .then((body) => {
                    LOGGER.debug('startMigration success', body);
                    vm.loading = false;
                    if (body.data.error && body.data.error.code === 404) {
                        LOGGER.debug('startMigration migration has warnings, displaying message according to error', body.data.error);
                        vm.emailService.setWarning(vm.customPwdWarnMessage)
                    } else {
                        LOGGER.debug('startMigration nothing to show as error message');
                    }
                    onCompletionGoTo.then(goToPhase => {
                        LOGGER.debug('going to ', goToPhase);
                        $state.go(goToPhase);
                    }, err => {
                        LOGGER.debug('error ', err);
                        $state.go(defaultGoToPhase);
                    });
                }, (err) => {
                    LOGGER.debug("startMigration failed", err);
                    vm.loading = false;
                    vm.errorMessage = '';
                    if (err.status === 409) {
                        // this.errorMessage = 'Questa casella è già stata configurata per avviare una migrazione';
                        onCompletionGoTo.then(goToPhase => {
                            $state.go(goToPhase);
                        }, err => {
                            $state.go(defaultGoToPhase);
                        });
                    } else if (err.status === 412) {
                        this.errorMessage = 'Credenziali non valide';
                    } else if (err.status === 500 && err.data.code === 132) {
                        this.errorMessage = 'Data di fine scaduta da meno di 3 mesi';
                    } else if (err.status === 500 && err.data.code === 130) {
                        this.errorMessage = 'Data di fine scaduta da piu di 3 mesi';
                    } else {
                        this.errorMessage = 'Si &egrave; verificato un errore. Si prega di riprovare';
                    }
                });
        } else {
            vm.errorMessage = 'input non validi';
        }
    };
    return vm;

  function isFilled(str) {
    return (str && str.trim().length > 0 );
  }
};



// WEBPACK FOOTER //
// ./client/components/pec-import-container/pec-import-controller.js